import { type StateCreator } from 'zustand';

export type PendingAnimatedUploadStep = {
  onboardingSaved: boolean;
  workspaceId: string;
  workspaceName: string;
};

export type PendingAnimatedQuestionsStep = {
  workspaceId: string;
  workspaceName: string;
};

export type PendingAnimatedUploadStepSlice = {
  pendingAnimatedQuestionsStep: PendingAnimatedQuestionsStep | null;
  pendingAnimatedUploadStep: PendingAnimatedUploadStep | null;
  setPendingAnimatedQuestionsStep: (step: PendingAnimatedQuestionsStep) => void;
  setPendingAnimatedUploadStep: (step: PendingAnimatedUploadStep) => void;
  clearPendingAnimatedQuestionsStep: () => void;
  clearPendingAnimatedUploadStep: () => void;
};

export const createPendingAnimatedUploadStepSlice: StateCreator<
  PendingAnimatedUploadStepSlice,
  [],
  [],
  PendingAnimatedUploadStepSlice
> = (set) => ({
  pendingAnimatedQuestionsStep: null,
  pendingAnimatedUploadStep: null,
  setPendingAnimatedQuestionsStep: (step) => set({ pendingAnimatedQuestionsStep: step }),
  setPendingAnimatedUploadStep: (step) => set({ pendingAnimatedUploadStep: step }),
  clearPendingAnimatedQuestionsStep: () => set({ pendingAnimatedQuestionsStep: null }),
  clearPendingAnimatedUploadStep: () => set({ pendingAnimatedUploadStep: null }),
});
